import React from 'react';
import PropTypes from 'prop-types';
import ResetPasswordWithTokenDialogFooter from './Components/ResetPasswordWithTokenDialogFooter';
import ResetPasswordWithTokenDialogContent from './Components/ResetPasswordWithTokenDialogContent';
import ResetPasswordWithTokenDialogHeader from './Components/ResetPasswordWithTokenDialogHeader';
import LoginPageWrapper from '../Components/LoginPageWrapper';

import './ResetPasswordWithTokenDialog.scss';

function ResetPasswordWithTokenDialog({
  close,
  responseStatus,
  trackAdobeAnalyticsError,
  setNewPassword,
  newPassword,
  setConfirmationPassword,
  confirmationPassword,
  submit,
  openForgotPasswordDialog,
  errorDetails,
}) {
  const [requestSent, setRequestSent] = React.useState(false);

  const handleSubmit = () => {
    setRequestSent(true);
    if (newPassword.isValid && confirmationPassword.isValid) {
      submit();
    }
  };

  return (
    <LoginPageWrapper className="react-page-reset-password-page" mainAriaLabel="Reset password screen">
      <div className="reset-password-with-token-dialog__content">
        <ResetPasswordWithTokenDialogHeader responseStatus={responseStatus} />
        <ResetPasswordWithTokenDialogContent
          requestSent={requestSent}
          newPassword={newPassword}
          confirmationPassword={confirmationPassword}
          setNewPassword={setNewPassword}
          setConfirmationPassword={setConfirmationPassword}
          responseStatus={responseStatus}
          trackAdobeAnalyticsError={trackAdobeAnalyticsError}
          openForgotPasswordDialog={openForgotPasswordDialog}
          errorDetails={errorDetails}
        />
        <ResetPasswordWithTokenDialogFooter submit={handleSubmit} close={close} responseStatus={responseStatus} />
      </div>
    </LoginPageWrapper>
  );
}

ResetPasswordWithTokenDialog.propTypes = {
  responseStatus: PropTypes.string,
  trackAdobeAnalyticsError: PropTypes.func.isRequired,
  newPassword: PropTypes.object.isRequired,
  setNewPassword: PropTypes.func.isRequired,
  confirmationPassword: PropTypes.object.isRequired,
  setConfirmationPassword: PropTypes.func.isRequired,
  openForgotPasswordDialog: PropTypes.func,
  errorDetails: PropTypes.string,
  close: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};

export default ResetPasswordWithTokenDialog;
